import { Directive, OnInit, inject } from '@angular/core';
import { LocalStorage } from '@df/browser/storage/decorator/local-storage';
import { CategoryComponentDef } from '@df/catalog-ui/category/category.component.def';
import { Category, ICategoryDataV3 } from '@df/catalog/category/category';
import { IModelDataV3WithUrl, Model } from '@df/catalog/model';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { Meta } from '@df/core/meta/meta';
import { onInViewChangeEvent } from '@df/ui/common/on-in-view.directive';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class CategoryViewComponentDef<
        T extends Category<ICategoryDataV3> = Category<ICategoryDataV3>,
        D extends Product<IProductDataV2> = Product<IProductDataV2>
    >
    extends CategoryComponentDef<T, D>
    implements OnInit
{
    @LocalStorage('lastCategoryPath')
    protected lastCategoryPath?: string;

    protected meta = inject(Meta);

    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(this.events.on(onInViewChangeEvent).subscribe(this.timeoutService.debounce(() => this.detectChanges(), 20)));
    }

    protected override onModelChange(): void {
        super.onModelChange();

        this.meta.model = <Model<IModelDataV3WithUrl>>this.model;
        if (this.model?.products.length) {
            this.lastCategoryPath = this.model?.data!.url;
        }
    }
}
